module.exports = __webpack_public_path__ + "static/img/interface_1_2.ab561d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faq/interface_1_2.jpg
// module id = EkPj
// module chunks = 1